<!-- 
  共通ヘッダコンポーネント
  ヘッダおよびグローバルナビ、サイト内検索が含まれます
 -->
<template>
  <div>
    <div v-if="isAdmin && businessDays" class="red-box">
      営業日切替中：{{ businessDays }}
    </div>

    <div v-if="systemEnvironment" class="red-box">
      {{ systemEnvironment }}
    </div>
    <header id="header1">
      <div class="cnt1 clearfix">
        <div>
          <h1>
            <a :href="portalTopUrl"
              ><img
                src="/WITH_AG_PORTAL/images/with-kaunet_logo-b.png"
                alt="ウィズカウネット"
                class="logo1"
              />
            </a>
          </h1>
        </div>

        <div>
          <div v-if="isAdmin">
            <router-link :to="adminManualUrl" class="com_link1">
              <span>本サイトについて（管理者様向け）</span>
            </router-link>
          </div>
          <div>
            <div class="text1">{{ agentCode }} ： {{ agentName }}</div>
            <div v-if="pseudoAgCode" class="text2">
              ［ {{ pseudoAgCode }} ： {{ pseudoAgName }} ］ {{ invoiceNo }}
            </div>
            <div v-else class="text2">{{ invoiceNo }}</div>
          </div>
          <div>
            <button
              type="button"
              name="btnLogout"
              class="button1"
              @click="logout"
            >
              <span class="text">
                <span class="text__item">ログアウト</span>
                <span class="text__item" aria-hidden="true">ログアウト</span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="cnt2 clearfix">
        <GlobalNavComponent />
      </div>
      <div v-if="!isAdminPage" class="cnt3 clearfix">
        <div class="com_search1">
          <ul>
            <li>
              <span class="text1">{{ selectedCategoryName }}</span>
              <div>
                <ul>
                  <li
                    v-for="category in allCategories"
                    :key="category.categoryId"
                  >
                    <input
                      type="radio"
                      name="selectCatF1"
                      :id="`selectCatF${category.categoryId}`"
                      :value="category.categoryId"
                      v-model="selectedCategoryId"
                    />
                    <label :for="`selectCatF${category.categoryId}`">{{
                      category.categoryName
                    }}</label>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div class="form1">
            <input
              name=""
              placeholder="キーワードから検索"
              @keyup.enter="siteSearch"
              v-model="serchKeyword"
              maxlength="50"
            />
            <button
              type="button"
              name="btnSiteSearch"
              @click="siteSearch"
            ></button>
          </div>
        </div>
        <!-- エラーメッセージの表示エリア -->
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
      </div>
    </header>

    <div id="fixed-header1">
      <div class="cnt1 clearfix">
        <div>
          <h1>
            <a :href="portalTopUrl"
              ><img
                src="/WITH_AG_PORTAL/images/with-kaunet_logo-b.png"
                alt="ウィズカウネット"
                class="logo1"
            /></a>
          </h1>
        </div>
        <div>
          <GlobalNavComponent />
        </div>
        <div>
          <div class="com_search1">
            <ul>
              <li>
                <span class="text1">{{ selectedCategoryName }}</span>
                <div>
                  <ul>
                    <li
                      v-for="category in allCategories"
                      :key="category.categoryId"
                    >
                      <input
                        type="radio"
                        name="selectCatF2"
                        :id="`selectCatF${category.categoryId}`"
                        :value="category.categoryId"
                        v-model="selectedCategoryId"
                      />
                      <label :for="`selectCatF${category.categoryId}`">{{
                        category.categoryName
                      }}</label>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <div class="form1">
              <input
                name=""
                value=""
                placeholder="キーワードから検索"
                @keyup.enter="siteSearch"
                v-model="serchKeyword"
                maxlength="50"
              />
              <button
                type="button"
                name="btnSiteSearch"
                @click="siteSearch"
              ></button>
            </div>
          </div>
        </div>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  ref,
  onMounted,
  onBeforeUnmount,
  defineComponent,
  watch,
  computed,
} from "vue";
import GlobalNavComponent from "./GlobalNavComponent.vue";
import { useUserStore } from "../../store/userStore";
import { AppConstants } from "@/constants/AppConstants";
import { useRouter } from "vue-router";
import logService from "@/services/logService";
import { useSiteSerchCategoryStore } from "../../store/siteSerchCategoryStore";
import {
  outputDebugLogs,
  formatMessage,
  sanitizeInput,
  isInputKeyword,
  trimKeyword,
  getPortalTopPath,
} from "@/Common";
import messages from "@/assets/messages.json";

export default defineComponent({
  name: "HeaderComponent",
  components: {
    GlobalNavComponent,
  },
  props: {
    externalPseudoAgentCode: String, // 疑似ログインAGコード
    externalPseudoAgentName: String, // 疑似ログインAG名称
    isAdminPage: Boolean, // 管理者ページかどうかのフラグ
  },
  setup(props, { emit }) {
    const { logoutUser } = useUserStore();
    const agentCode = ref<string | null>(null);
    const agentName = ref<string | null>(null);
    const pseudoAgCode = ref<string | null>(null);
    const pseudoAgName = ref<string | null>(null);
    const invoiceNo = ref<string | null>(null);
    const isAdmin = ref<boolean>(false);
    const router = useRouter();
    const { items } = useSiteSerchCategoryStore();
    const selectedCategoryId = ref("000");
    const selectedCategoryName = ref("すべてのカテゴリ");
    const serchKeyword = ref("");
    const errorMessage = ref("");
    const portalTopUrl = computed(() => getPortalTopPath());
    const adminManualUrl = ref("");
    const businessDays = ref<string | null>(null);
    const systemEnvironment = ref("");

    /**
     * サイト内検索カテゴリに「すべてのカテゴリ」を追加したリスト
     */
    const allCategories = computed(() => [
      { categoryId: "000", categoryName: "すべてのカテゴリ" },
      ...items.value,
    ]);

    /**
     * サイト内検索カテゴリの選択状態を監視
     */
    watch(selectedCategoryId, (newId) => {
      outputDebugLogs("selectedCategoryId Id:" + newId);
      const selectedCategory = items.value.find(
        (category) => category.categoryId === newId
      );
      if (selectedCategory) {
        selectedCategoryName.value = selectedCategory.categoryName;
      }
    });

    /**
     * 疑似ログインAGコードの変更を監視
     */
    watch(
      () => props.externalPseudoAgentCode,
      (newValue) => {
        pseudoAgCode.value = newValue !== undefined ? newValue : null;
      },
      { immediate: true }
    );

    /**
     * 疑似ログインAG名称の変更を監視
     */
    watch(
      () => props.externalPseudoAgentName,
      (newValue) => {
        pseudoAgName.value = newValue !== undefined ? newValue : null;
      },
      { immediate: true }
    );

    /**
     * 初期処理
     */
    onMounted(() => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agentCode.value = parsedUserInfo.agCode;
        agentName.value = parsedUserInfo.agName;
        pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
        pseudoAgName.value = parsedUserInfo.pseudoAgName;
        invoiceNo.value = parsedUserInfo.invoiceNo;
        isAdmin.value = parsedUserInfo.isAdmin;
      }

      serchKeyword.value = "";
      outputDebugLogs(
        "process.env.VUE_APP_ADMIN_MANUAL_URL:" +
          process.env.VUE_APP_ADMIN_MANUAL_URL
      );
      // 本サイトについて（管理者様向け）のURLを環境変数から取得
      adminManualUrl.value = process.env.VUE_APP_ADMIN_MANUAL_URL;

      // 営業日を取得 営業日切替されていない場合は空文字
      businessDays.value = localStorage.getItem(
        AppConstants.BUSINESS_DAYS_SESSION_NAME
      );

      // アプリ稼働環境（検証環境など）の文字列を設定
      systemEnvironment.value = process.env.VUE_APP_ENVIRONMENT;
      outputDebugLogs("systemEnvironment.value:" + systemEnvironment.value);
    });

    /**
     * ログアウト処理
     */
    function logout() {
      // 確認ダイアログ表示
      const isConfirm = window.confirm(formatMessage(messages.CNF_0006));

      // OK以外なら処理しない
      if (!isConfirm) {
        return;
      }

      const userStore = useUserStore();

      // ログアウトのログ用データを設定
      const logData = {
        systemkbn: AppConstants.SYSTEM_KBN_WITH,
        userId: userStore.state.userId || "0000000000",
        agCode: userStore.state.agCode || "00000000",
        actionTime: new Date().toISOString(),
        operationType: AppConstants.OP_TYPE_LOGOUT,
        pseudoAgCode: userStore.state.pseudoAgCode,
        pseudoUserId: userStore.state.pseudoUserId,
        fromScreenName: "ログアウト",
        toScreenName: "",
        controlName: "",
        actionDetail: "ログアウト",
        genericField1: "",
        genericField2: "",
        genericField3: "",
        currentUrl: window.location.href,
      };

      // ログを出力
      logService.sendLog(logData);

      // ログアウト処理を実行して、ローカルストレージから情報を削除
      logoutUser();

      // デバック用
      if (process.env.VUE_APP_DEBUG === "true") {
        console.log("ログアウト処理を実行");
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          console.log(
            "parsedUserInfo.agentCode:",
            JSON.parse(userInfo).agentCode
          );
          console.log(
            "parsedUserInfo.isLoggedIn:",
            JSON.parse(userInfo).isLoggedIn
          );
        }
      }
      // デバック用ここまで

      // 親コンポーネントにイベントを通知
      emit("logout");

      // ログアウト画面へ遷移
      router.push("/logout");
    }

    /**
     * サイト内検索
     */
    function siteSearch() {
      try {
        outputDebugLogs("サイト内検索");
        errorMessage.value = "";
        const sanitizedKeyWord = sanitizeInput(serchKeyword.value, true);
        // 入力チェック
        if (!isInputKeyword(sanitizedKeyWord)) {
          errorMessage.value = formatMessage(messages.ERR_0001, "キーワード");
          return;
        }

        // 1文字の場合はNG
        if (trimKeyword(sanitizedKeyWord).length <= 1) {
          errorMessage.value = formatMessage(
            messages.ERR_0028,
            "キーワード",
            "2"
          );
          return;
        }

        if (selectedCategoryId.value == "000") {
          selectedCategoryId.value = "";
        }

        // サイト内検索画面へ
        router.push({
          path: "/site-serch",
          query: {
            keyWord: sanitizedKeyWord,
            categoryId: selectedCategoryId.value,
          },
        });

        return;
      } finally {
        serchKeyword.value = "";
        selectedCategoryId.value = "000";
        selectedCategoryName.value = "すべてのカテゴリ";
      }
    }

    /**
     * スクロールしたらヘッダが付いてくるやつ
     */
    const handleScroll = () => {
      const header = document.getElementById("fixed-header1");
      const headerTrigger: HTMLElement | null =
        document.getElementById("header1");
      if (header && headerTrigger) {
        if (window.scrollY > headerTrigger.offsetHeight) {
          header.classList.add("on");
        } else {
          header.classList.remove("on");
        }
      }
    };

    // スクロールイベントの登録と解除
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      agentCode,
      agentName,
      pseudoAgCode,
      pseudoAgName,
      invoiceNo,
      isAdmin,
      logout,
      siteSearch,
      items,
      selectedCategoryId,
      selectedCategoryName,
      allCategories,
      serchKeyword,
      errorMessage,
      portalTopUrl,
      adminManualUrl,
      businessDays,
      systemEnvironment,
    };
  },
});
</script>
<style scoped>
.red-box {
  position: absolute;
  top: 15px; /* 上から10pxの位置に配置 */
  left: 450px; /* 左から20pxの位置に配置 */
  border: 2px solid red;
  color: red;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: white;
  z-index: 1000; /* 他の要素より上に表示 */
}
</style>
